export const navigateToUrl = (link) => { window.open(link) }